// extracted by mini-css-extract-plugin
export default {"uploadWrapper":"upload_uploadWrapper__h90Nd","plusIcon":"upload_plusIcon__xjO5B"};